import React from 'react';

import { PageShell } from '$partials/global/index.js';
import Util from '$utilities';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').ErrorPage}
 *
 * Renders a failure in the site's own furniture, so that a visitor who lands
 * here has the navigation to leave by.
 * 1. The global settings are fetched alongside the error, and are missing when
 *    the CMS is what failed. The shell renders whatever it has.
 */
const ErrorPage = (props) => {
    const status = Util.try(() => props?.err?.statusCode) || 500;

    let message = '';

    switch (status) {
        case 404:
            message = '404 - Page not found.';
            break;

        default:
            message = 'Sorry, something went wrong.';
    }

    /* [1] */
    return (
        <PageShell
            banner
            footer={props.data?.footer}
            header={props.data?.header}>
            <div className='layout-container bg-neutral-00'>
                <div className='py-60 sm:py-100'>
                    <h1 className='type-style-heading'>
                        {message}
                    </h1>
                </div>
            </div>
        </PageShell>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ErrorPage;
